export default __webpack_public_path__ + "static/media/photo1.afc4a750.jpg";